import React, { useState, useEffect } from "react";
import "./Css/QueMangment.css";
import axios from "axios";
import { useNavigate } from 'react-router-dom'
import API_BASE from "../config/api";

const QueMangment = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [examList, setExamList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
   const [softwares, setSoftwares] = useState([]);
  const [standards, setStandards] = useState([]);
  const [subjects, setSubjects] = useState([]);
 const [paperTypes, setPaperTypes] = useState([]);
  const [selectedPaperType, setSelectedPaperType] = useState('');
  const [selectedSoftware, setSelectedSoftware] = useState('');
  const [selectedStandard, setSelectedStandard] = useState('');
  const [selectedSubject, setSelectedSubject] = useState('');
   useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/questions/dropdowns`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setSoftwares(res.data.softwares);
        setStandards(res.data.standards);
        setSubjects(res.data.subjects);
      } catch (err) {
        console.error("Error fetching dropdowns:", err);
      }
    };
    fetchDropdowns();
  }, [token]);

useEffect(() => {
  const fetchQuestions = async () => {
    try {
      const response = await axios.get(`${API_BASE}/api/questions`, {
        params: {
          search: searchQuery,
          standardId: null,
          softwareId: null,
          paperType: null,
          subjectId: null,
            paperType: selectedPaperType || null,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("API data:", response.data); // debug
const normalizedData = response.data.map((q) => ({
  Id: q.id,
  question: q.questionText || '',
  op1: q.optionA || 'N/A',
  op2: q.optionB || 'N/A',
  op3: q.optionC || 'N/A',
  op4: q.optionD || 'N/A',
  answer: q.correctAnswer || 'N/A',
  Topic: q.topic || '',
  Subtopic: q.subtopic || ''
}));
console.log(Object.keys(response.data[0]))

console.log(response.data[0])

      console.log("Normalized data:", normalizedData); // debug
      setExamList(normalizedData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching questions:", error);
      setLoading(false);
    }
  };

  fetchQuestions();
}, [searchQuery, token]);



  if (loading) return <p>Loading questions...</p>;

  const filteredData = examList.filter((item) =>
    [item.question, item.Topic, item.Subtopic, item.op1, item.op2, item.op3, item.op4]
      .some((field) => field?.toLowerCase().includes(searchQuery.toLowerCase()))
  );

const totalPages = Math.max(Math.ceil(filteredData.length / rowsPerPage), 1);

const paginatedData = filteredData.slice(
  (currentPage - 1) * rowsPerPage,
  currentPage * rowsPerPage
);


  return (
    <div className="qb-container">
      <div className="exam-header">
        <h3>प्रश्न संच  </h3>
        <div className="edit-btnn">
          <button className="primary-btn" onClick={() => navigate("/dashboard/addqueform")}
          >प्रश्न जोडा</button>
        </div>
      </div>
      <div className="filters">
        <div className="search-wrapper-exam">
          <svg xmlns="http://www.w3.org/2000/svg" className="search-icon-exam" height="20" width="20" viewBox="0 0 24 24" fill="#888">
            <path d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z" fill="#848484" /></svg>
          <input className="udises" type="text" placeholder="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
        </div>
       <select value={selectedSoftware} onChange={(e) => setSelectedSoftware(e.target.value)}>
          <option value="">परीक्षेचे नाव</option>
          {softwares.map(s => (
            <option key={s.id} value={s.id}>{s.name}</option>
          ))}
        </select>
       <select
  value={selectedPaperType}
  onChange={(e) => setSelectedPaperType(e.target.value)}
>
  <option value="">परीक्षा प्रकार</option>
  {paperTypes.map((p) => (
    <option key={p.id} value={p.id}>
      {p.name}
    </option>
  ))}
</select>

       <select value={selectedStandard} onChange={(e) => setSelectedStandard(e.target.value)}>
          <option value="">इयत्ता</option>
          {standards.map(s => (
            <option key={s.id} value={s.id}>{s.name}</option>
          ))}
        </select>
        <select value={selectedSubject} onChange={(e) => setSelectedSubject(e.target.value)}>
          <option value="">विषय</option>
          {subjects.map(s => (
            <option key={s.id} value={s.id}>{s.name}</option>
          ))}
        </select>

      </div>
      <div className="qb-table-wrapper">
        <table className="qb-table">
          <thead>
            <tr>
              <th>क्र.</th>
              <th>घटक</th>
              <th>उपघटक</th>
              <th>प्रश्न</th>
              <th>पर्याय १</th>
              <th>पर्याय २</th>
              <th>पर्याय ३</th>
              <th>पर्याय ४</th>
              <th>उत्तर</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((item, index) => (
              <tr key={item.Id}>
                <td>{index + 1}</td>
                <td>{item.Topic || '-'}</td>
        <td>{item.Subtopic || '-'}</td>
                <td className="question-text">{item.question}</td>
                <td>{item.op1}</td>
                <td>{item.op2}</td>
                <td>{item.op3}</td>
                <td>{item.op4}</td>
                <td className="answer-cell">
                  {item.answer}
                  <span className="tick"> ✅</span>
                  <span className="info"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M11 17H13V11H11V17ZM12 9C12.2833 9 12.5208 8.90417 12.7125 8.7125C12.9042 8.52083 13 8.28333 13 8C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7167 7 11.4792 7.09583 11.2875 7.2875C11.0958 7.47917 11 7.71667 11 8C11 8.28333 11.0958 8.52083 11.2875 8.7125C11.4792 8.90417 11.7167 9 12 9ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="#848484" />
                  </svg></span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className='que-pagination-container'>
        <div className="que-pagination-controlss">
          <button
            className="que-pagination-btn"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            &lt;
          </button>
          {[...Array(totalPages).keys()]
            .map((_, i) => i + 1)
            .slice(
              Math.max(currentPage - 2, 0),
              Math.min(currentPage + 1, totalPages)
            )
            .map((page) => (
              <button
                key={page}
                className={`que-pagination-btn ${currentPage === page ? 'active' : ''
                  }`}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            ))}
          <button
            className="que-pagination-btn"
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
          <div className="que-pagination-controls">
            <span className="que-rows-label">Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              className="que-rows-dropdown"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QueMangment;
